import { Directive, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';

import { CookiesService } from '@shared/services/cookie.service';
import { CookieAgreementComponent } from './cookie-agreement.component';

@Directive({
  selector: '[appCookieAgreement]',
})
export class CookieAgreementDirective {

  get hasAgreement(): boolean {
    return !!this.cookieService.getCookie('cookie-agreement');
  }

  constructor(
    private cookieService: CookiesService,
    private snackBar: MatSnackBar,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      if (!this.hasAgreement) {
        this.openSnackBar();
      }
    }
  }

  openSnackBar() {
    this.snackBar.openFromComponent(CookieAgreementComponent);
  }
}
